import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

// Public
export function signerTypes() {
	return Auth.GET(`/Notarization/Signers/Types`);
}

export function identityVerificationStatuses() {
	return Auth.GET(`/Notarization/Signers/IdentityVerificationStatuses`);
}

export function addSigner(notarizationId, signer) {
	return Auth.POST(`/Notarization/${notarizationId}/Signers`, signer);
}

export function signers(notarizationId) {
	return Auth.GET(`/Notarization/${notarizationId}/Signers`);
}

export function deleteSigner(notarizationId, signerId) {
	return Auth.DELETE(`/Notarization/${notarizationId}/Signers/${signerId}`);
}

export function signerDetails(notarizationId, signerId) {
	return Auth.GET(`/Notarization/${notarizationId}/Signers/${signerId}`);
}

export function updateSignerDetails(notarizationId, signerId, details) {
	return Auth.PUT(`/Notarization/${notarizationId}/Signers/${signerId}`, details);
}